module.exports = __webpack_public_path__ + "static/media/ios-download.f0d4c53e.png";